<template>
  <div class="sundial-container">
    <svg
      ref="sundial"
      class="sundial"
      viewBox="0 0 800 800"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <rect
          ref="bar"
          :height="height"
          class="bar"
          width="1.3"
        />
      </defs>
      <g
        ref="barContainer"
        class="barContainer"
      />
    </svg>
  </div>
</template>

<script>
import {
  TimelineMax,
  TweenMax,
  Power1,
  Linear,
} from 'gsap'

import { CustomEase } from '../js/CustomEase'

export default {
  props: {
    width: {
      type: Number,
      default: 414,
    },

    height: {
      type: Number,
      default: 150,
    },

    rotate: {
      type: Boolean,
      default: true,
    },

    progress: {
      type: Number,
      default: 0,
    },

    timelineMode: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    bar: undefined,
    myEase: undefined,
    numSegs: 0,
    centerX: 0,
    centerY: 0,
    barStep: 0,
    barArray: [],
    timeline: new TimelineMax(),
    circleRadius: 0,
    barContainer: undefined,
    sundial: undefined,
    currentFill: '',
    progressPercentage: 0,
    options: {},
    intersectionObserver: undefined,
    point: {},
  }),

  mounted() {
    this.options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    }

    this.intersectionObserver = new IntersectionObserver(this.animationState, this.options)
    this.intersectionObserver.observe(this.$el)

    this.bar = this.$refs.bar
    this.sundial = this.$refs.sundial
    this.barContainer = this.$refs.barContainer

    this.numSegs = 147
    this.progressPercentage = 100 / this.progress

    this.centerX = 400
    this.centerY = 400
    this.circleRadius = this.width
    this.step = 360 / this.numSegs

    this.myEase = new CustomEase('wavey', 'M0, 0 C0.266, 0.412 0.117, 0.805 0.294, 0.816 0.462, 0.826 0.385, 0.418 0.526, 0.418 0.786, 0.418 0.811, 0.899 0.86, 0.96 0.892, 1 0.941, 1 1, 1')

    this.animation()
  },

  methods: {
    handleFill(index) {
      if ((!this.rotate && index <= (this.numSegs / this.progressPercentage)) || this.rotate) {
        this.currentFill = '#EDB210'
      } else {
        this.currentFill = '#DDDDDD'
      }
    },

    animateRotation() {
      this.timeline.add(
        TweenMax.to(
          this.sundial,
          250,
          {
            repeat: -1,
            ease: Linear.easeNone,
            rotation: '360',
            transformOrigin: '50% 50%',
          },
        ),
      )
    },

    staticRotation() {
      this.timeline.add(
        TweenMax.set(
          this.sundial,
          {
            rotation: '270',
            transformOrigin: '50% 50%',
          },
        ),
      )
    },

    animationState(entry) {
      return entry[0].isIntersecting ? this.timeline.play() : this.timeline.pause()
    },

    animation() {
      for (let index = 0; index < this.numSegs; index += 1) {
        const barClone = this.bar.cloneNode(true)

        this.barContainer.appendChild(barClone)
        const angle = (this.step * index)

        this.point = {
          x: (Math.cos((angle * Math.PI) / 180) * this.circleRadius) + this.centerX,
          y: ((Math.sin((angle * Math.PI) / 180) * this.circleRadius) + this.centerY) - this.height,
        }

        this.handleFill(index)

        TweenMax.set(barClone, {
          x: this.point.x,
          y: this.point.y,
          rotation: (angle) + 90,
          transformOrigin: '50% 100%',
          scaleY: 0,
        })

        if (!this.rotate) {
          TweenMax.fromTo(
            barClone,
            1,
            {
              fill: '#DDDDDD',
            },
            {
              delay: index * 0.02,
              ease: Power1.easeOut,
              fill: this.currentFill,
            },
          )
        } else {
          TweenMax.set(barClone, {
            fill: '#EDB210',
          })
        }

        this.barArray.push(barClone)

        const barsTween = TweenMax.to(
          {},
          4,
          {
            repeat: -1,
            delay: 3 * index,
            ease: Power1.easeOut,
            yoyo: true,
            onUpdate: () => {
              TweenMax.to(barClone, 3, {
                scaleY: this.myEase.getRatio(barsTween.progress()) * 1.5,
              })
            },
          },
        )
        this.timeline.add(barsTween, index / 20)
      }
      this.timeline.seek(1000)

      if (this.rotate) {
        this.animateRotation()
      } else {
        this.staticRotation()
      }
    },
  },
}
</script>

<style lang="scss">
.sundial-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.sundial {
  width: 100%;
  height: 100%;
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/AnimationSundial.vue